module.exports = __webpack_public_path__ + "resources/img/img_sqml_di2_en.43f13341e89e453a29c2c3b125a3478d.png";